/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Announcement } from '../models/announcement';
import { ApiResponseAnnouncement } from '../models/api-response-announcement';
import { ApiResponseAnnouncementStats } from '../models/api-response-announcement-stats';
import { ApiResponsePagedResultAnnouncement } from '../models/api-response-paged-result-announcement';
import { createAnnouncement } from '../fn/announcement-api/create-announcement';
import { CreateAnnouncement$Params } from '../fn/announcement-api/create-announcement';
import { deleteAnnouncement } from '../fn/announcement-api/delete-announcement';
import { DeleteAnnouncement$Params } from '../fn/announcement-api/delete-announcement';
import { getListAnnouncement } from '../fn/announcement-api/get-list-announcement';
import { GetListAnnouncement$Params } from '../fn/announcement-api/get-list-announcement';
import { getStats } from '../fn/announcement-api/get-stats';
import { GetStats$Params } from '../fn/announcement-api/get-stats';
import { updateAnnouncement } from '../fn/announcement-api/update-announcement';
import { UpdateAnnouncement$Params } from '../fn/announcement-api/update-announcement';

@Injectable({ providedIn: 'root' })
export class AnnouncementApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateAnnouncement()` */
  static readonly UpdateAnnouncementPath = '/v1/api/admin-ui/announcement/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnnouncement$Response(params: UpdateAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnnouncement>> {
    return updateAnnouncement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnnouncement(params: UpdateAnnouncement$Params, context?: HttpContext): Observable<ApiResponseAnnouncement> {
    return this.updateAnnouncement$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAnnouncement>): ApiResponseAnnouncement => r.body)
    );
  }

  /** Path part for operation `getListAnnouncement()` */
  static readonly GetListAnnouncementPath = '/v1/api/admin-ui/announcement/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListAnnouncement$Response(params: GetListAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAnnouncement>> {
    return getListAnnouncement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListAnnouncement(params: GetListAnnouncement$Params, context?: HttpContext): Observable<ApiResponsePagedResultAnnouncement> {
    return this.getListAnnouncement$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAnnouncement>): ApiResponsePagedResultAnnouncement => r.body)
    );
  }

  /** Path part for operation `createAnnouncement()` */
  static readonly CreateAnnouncementPath = '/v1/api/admin-ui/announcement/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnnouncement$Response(params: CreateAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnnouncement>> {
    return createAnnouncement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnnouncement(params: CreateAnnouncement$Params, context?: HttpContext): Observable<ApiResponseAnnouncement> {
    return this.createAnnouncement$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAnnouncement>): ApiResponseAnnouncement => r.body)
    );
  }

  /** Path part for operation `getStats()` */
  static readonly GetStatsPath = '/v1/api/admin-ui/announcement/{ref}/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStats$Response(params: GetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnnouncementStats>> {
    return getStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStats(params: GetStats$Params, context?: HttpContext): Observable<ApiResponseAnnouncementStats> {
    return this.getStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAnnouncementStats>): ApiResponseAnnouncementStats => r.body)
    );
  }

  /** Path part for operation `deleteAnnouncement()` */
  static readonly DeleteAnnouncementPath = '/v1/api/admin-ui/announcement/delete/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAnnouncement()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAnnouncement$Response(params: DeleteAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    return deleteAnnouncement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAnnouncement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAnnouncement(params: DeleteAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    return this.deleteAnnouncement$Response(params, context).pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

}
